import { useState, useEffect, useRef } from 'react';
import { Truck, FileSpreadsheet, CheckCircle, AlertCircle, Download } from 'lucide-react';
import Crud_Catalogos from '../../herramientas/Crud_Catalogos';
import './stylesDownloader.css'

const ExcelDownloadLoader = (props) => {
  // Modo controlado: el padre maneja el progreso/estado (sin polling al backend).
  const { manual = false } = props;
  const [downloadStatus, setDownloadStatus] = useState(manual ? 'PROCESS' : 'idle'); // idle, loading, completed, error
  const [progress, setProgress] = useState(0);
  const [downloadId, setDownloadId] = useState(null);
  const intervalRef = useRef(null);


  useEffect(() => {
    if (manual) return; // en modo controlado no se hace polling
    console.log(props.data)
    if(props?.data?.status?.includes("STARTED")){
      setDownloadStatus('STARTED');
      setProgress(0);
      startDownload(props.data)
    }else{
      throw new Error('Error al iniciar descarga');
    }

  }, [])

  // En modo controlado refleja el progreso/estado recibido por props.
  useEffect(() => {
    if (!manual) return;
    if (typeof props.progress === 'number') setProgress(props.progress);
    if (props.status) setDownloadStatus(props.status);
  }, [manual, props.progress, props.status]);
  

  // Simular inicio de descarga
  const startDownload =  (data) => {
 
        setDownloadId(data.taskId);
        startPolling(data.taskId);
        
  };



  const getfuntion = (
    metodo = "get",
    params,
    id = "",
    endPoint,
    stateVar = "",
    hiddenModl = ""
  ) => {
    Crud_Catalogos(
      endPoint,
      "",
      metodo,
      id,
      params,

    ).then((returnVal) => {
      if(returnVal){
        if(endPoint.includes("status")){    
         console.log(returnVal)
          if (returnVal.status === 'COMPLETED') {
         
            setDownloadStatus('COMPLETED');
            setProgress(100);
            clearInterval(intervalRef.current);
            getfuntion("get","","","reporteAsignaciones/download/file/" +props.data.taskId)
          } else {
            setDownloadStatus(returnVal.progress == 0 ? "LOADING" : "PROCESS");
            setProgress(returnVal.progress);
            //clearInterval(intervalRef.current);
          }
        }else if(endPoint.includes("file")){
          downloadFile(returnVal);
        }
      }

    })};

  // Polling para verificar estado
  const startPolling = (id) => {
    intervalRef.current = setInterval(async () => {
      try {
        /* Código real para API:*/
        getfuntion("get","","","reporteAsignaciones/download/status/" +id)
     

        
      } catch (error) {
        console.error('Error verificando estado:', error);
        setDownloadStatus('error');
        clearInterval(intervalRef.current);
      }
    }, 1500);
  };

  // Descargar archivo
  const downloadFile = (file) => {
    // Crear blob simulado para demo
    const csvContent = file
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = 'reporte_excel.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    resetDownload()
  };

  // Limpiar interval al desmontar
  useEffect(() => {
    return () => {

      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  // Reiniciar proceso

    async function resetDownload() {
      console.log("Before sleep");
      await sleep(3000); // Pause execution for 2 seconds
      props.reset()
    }
    
    const sleep = (ms) => {
      return new Promise((resolve) => setTimeout(resolve, ms));
    };

  return (  
      <div href="#siguiente-seccion"  className="excel-download-container btn-next">
      <div className="download-card">
        
        {/* Header */}
        {/* <div className="header">
          <div className="header-title">
            <FileSpreadsheet className="excel-icon" />
            <h2 className="title">Descarga Excel</h2>
          </div>
          
        </div> */}

        {/* Loader del Camión */}

        {downloadStatus != 'idle' && (
          <div className="loader-container-download">
            <div className="road-container-download">
              {/* Carretera */}
              <div className="road-download"></div>
              <div className="road-line-download"></div>
              
              {/* Camión animado */}
              <div 
                className="truck-download"
                style={{ 
                  left: `${Math.min(progress, 85)}%`
                }}
              >
                <div>
                  {/* Cuerpo del camión */}
                  <div className="truck-body-download">
                    <div className="truck-window-download"></div>
                    <div className="truck-cargo-download"></div>
                  </div>
                  
                  {/* Cabina */}
                  <div className="truck-cabin-download">
                    <div className="cabin-window-download"></div>
                  </div>
                  
                  {/* Ruedas */}
                  <div className="wheel-download wheel-1-download"></div>
                  <div className="wheel-download wheel-2-download"></div>
                  <div className="wheel-download wheel-3-download"></div>
                  
                  {/* Humo */}
                  <div className="smoke-download">
                    <div className="smoke-particle-download"></div>
                    <div className="smoke-particle-download"></div>
                    <div className="smoke-particle-download"></div>
                  </div>
                </div>
              </div>
              
              {/* Indicador Excel */}
              <div className="excel-indicator">
                <FileSpreadsheet className="excel-indicator-icon" />
              </div>
            </div>
            
            {/* Barra de progreso */}
            {downloadStatus === "PROCESS" && (
            <div className="progress-section">
              <div className="progress-header">
                <span className="progress-label">Progreso</span>
                <span className="progress-label">{Math.round(progress)}%</span>
              </div>
              <div className="progress-bar-container">
                <div 
                  className="progress-bar-excel"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>
           )}

          {downloadStatus === "LOADING" && (
            <div className="progress-section">
              <div className="progress-header">
                <span className="progress-label">OBTENIENDO DATOS</span>
              
              </div>
              <div className="progress-bar-container">
                <div 
                  className="progress-bar"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>
           )}

            
            <p className="loading-text">
              Preparando tu archivo Excel...
            </p>
          </div>
        )}
        
        {/* Estado Completado */}
        {downloadStatus === 'COMPLETED' && (
          <div className="status-container">
            <div className="status-icon success">
              <CheckCircle className="status-icon-svg success" />
            </div>
            <h3 className="status-title">¡Descarga Completadas!</h3>
            <p className="status-message">Tu archivo Excel ha sido descargado exitosamente</p>
          </div>
        )}

        {/* Estado Error */}
        {downloadStatus === 'error' && (
          <div className="status-container">
            <div className="status-icon error">
              <AlertCircle className="status-icon-svg error" />
            </div>
            <h3 className="status-title">Error en la Descarga</h3>
            <p className="status-message">Hubo un problema al generar el archivo</p>
          </div>
        )}


        {downloadId && (
          <div className="download-id">
            <p className="download-id-text">ID: {downloadId}</p>
          </div>
        )}
      </div>
  </div>
  );
};

export default ExcelDownloadLoader;